export default {
  formTitle: 'Contact us',
  submit: 'Send',
  mail: 'Email',
  name: 'Name',
  comment: 'Message',
  sendText: 'Thanks for contacting us!',
  toForm: 'Back'
}


// WEBPACK FOOTER //
// ./src/locale/en-US/contactUs.js